import { type ReadonlyRequestCookies } from 'next/dist/server/web/spec-extension/adapters/request-cookies';

import KafkaRestClient from '../kafka/KafkaRestClient';
import lookupUser from '../shared/lookupUser';
import { SignupSurveyEventFactory } from './SignupSurveyEventFactory';

export async function publishEvent(cookies: ReadonlyRequestCookies, channel: string, comment: string): Promise<void> {
    const visitorIdCookie = cookies.get('VID')?.value ?? null;
    const loginSessionToken = cookies.get('login_session')?.value;

    const event = await SignupSurveyEventFactory.create({
        visitorCookieId: visitorIdCookie,
        sessionToken: loginSessionToken,
        channel,
        comment,
    });

    await KafkaRestClient.produce(event);
}

export const SignupSurveyEventService = { publishEvent };
